// extracted by css-extract-rspack-plugin
export default {"caption":"BreadCrumbItem_caption__pmZhO"};